<template>
	<div class="relative">
		<input type="hidden" :name="name" :value="value">
		<input
			@click="$emit('input', value ? 0 : 1)"
			class="absolute w-full h-full opacity-0 cursor-pointer z-40"
			:class="{ 'cursor-not-allowed': isDisabled }"
			type="checkbox"
			:value="value"
			:disabled="isDisabled"
		>
		<span
			class="relative inline-block flex-no-shrink border-2 border-transparent rounded-full shadow-sm cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
			:class="{
				'bg-gray-200': ! value || isDisabled,
				'bg-indigo-300': value && isDisabled,
				'bg-indigo-600': value && ! isDisabled
			}"
			role="checkbox"
			tabindex="0"
			:aria-checked="value"
			style="width:4.3rem; height: 2.24rem;"
		>
			<span
				aria-hidden="true"
				:class="{ 'translate-x-8': value, 'translate-x-0': ! value }"
				class="relative inline-block h-8 w-8 rounded-full bg-white shadow transform transition ease-in-out duration-200"
			>
				<span
					:class="{ 'opacity-0 ease-out duration-100': value, 'opacity-100 ease-in duration-200': ! value }"
					class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
				>
					<svg class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 12 12">
						<path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</span>
				
				<span
					:class="{ 'opacity-100 ease-in duration-200': value, 'opacity-0 ease-out duration-100': ! value }"
					class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
				>
					<svg
						class="h-5 w-5"
						:class="value && ! isDisabled ? 'text-indigo-600' : 'text-indigo-300'"
						fill="currentColor" viewBox="0 0 12 12"
					>
						<path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
					</svg>
				</span>
			</span>
		</span>
	</div>
</template>

<script>
	export default {
		props: {
			name: {
				type: String,
				required: false
			},

			value: {
				required: true
			},

			isDisabled: {
				type: Boolean,
				default: false
			}
		}
	}
</script>